import {ThreeDSecureFlow} from '../api/generated';
import {AnchorLink} from './AnchorLink';
import React from 'react';

export const ThreeDSecureFlowHint: React.FC<{threeDSecureFlow: ThreeDSecureFlow}> = ({
  threeDSecureFlow
}) => {
  switch (threeDSecureFlow) {
    case ThreeDSecureFlow.CHALLENGE:
      return (
        <>
          In a challenge flow, the issuer requires additional shopper interaction, either through
          biometrics, two-factor authentication, or similar methods based on{' '}
          <AnchorLink href="https://en.wikipedia.org/wiki/Strong_customer_authentication">
            Strong Customer Authentication (SCA)
          </AnchorLink>{' '}
          factors.
        </>
      );

    case ThreeDSecureFlow.FRICTIONLESS:
      return (
        <>
          In a frictionless flow, the acquirer, issuer, and card scheme exchange all necessary
          information in the background through passive authentication using the shopper's device
          fingerprint. The transaction is completed without further shopper interaction.
        </>
      );

    case ThreeDSecureFlow.DIRECT:
      return (
        <>
          This transaction did not require{' '}
          <AnchorLink href="https://en.wikipedia.org/wiki/Strong_customer_authentication">
            Strong Customer Authentication (SCA)
          </AnchorLink>{' '}
          due to the low risk. This means that, the customer didn’t have to go through the extra
          authentication steps to confirm that they are who they say they are.
        </>
      );

    case ThreeDSecureFlow.FRICTIONLESS_CHALLENGE:
      return (
        <>
          This flow is the complete 3DS flow. It is similar to the 3DS frictionless flow but
          includes an additional authentication step (challenge) that will be invoked if the
          information provided in the data collection step does not suffice to determine the
          risk-level of the transaction.
        </>
      );
  }
};
